var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.7C6.49368 2.7 6.00809 2.88964 5.65007 3.22721C5.29204 3.56477 5.09091 4.02261 5.09091 4.5C5.09091 4.97739 5.29204 5.43523 5.65007 5.77279C6.00809 6.11036 6.49368 6.3 7 6.3C7.50632 6.3 7.99191 6.11036 8.34993 5.77279C8.70796 5.43523 8.90909 4.97739 8.90909 4.5C8.90909 4.02261 8.70796 3.56477 8.34993 3.22721C7.99191 2.88964 7.50632 2.7 7 2.7ZM7 7.5C6.15613 7.5 5.34682 7.18393 4.75011 6.62132C4.15341 6.05871 3.81818 5.29565 3.81818 4.5C3.81818 3.70435 4.15341 2.94129 4.75011 2.37868C5.34682 1.81607 6.15613 1.5 7 1.5C7.84387 1.5 8.65318 1.81607 9.24988 2.37868C9.84659 2.94129 10.1818 3.70435 10.1818 4.5C10.1818 5.29565 9.84659 6.05871 9.24988 6.62132C8.65318 7.18393 7.84387 7.5 7 7.5ZM7 0C3.81818 0 1.10091 1.866 0 4.5C1.10091 7.134 3.81818 9 7 9C10.1818 9 12.8991 7.134 14 4.5C12.8991 1.866 10.1818 0 7 0Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.b77cb850ffb98ae8444406219f338592.svg";
export { ForwardRef as ReactComponent };